import { render, staticRenderFns } from "./spacer.vue?vue&type=template&id=1e7dff5e&"
import script from "./spacer.vue?vue&type=script&lang=js&"
export * from "./spacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports